<template>
    <div class="page-container">
        <div class="top-notice">请根据自己的进货单进行申请发票</div>
        <div class="invoice-list">
            <div class="stock-item">
                <div class="time-status">
                    <span>订单编号：32989108123098</span>
                </div>
                <div class="goods-bock">
                    <div class="goods-info-block">
                        <img src="" class="goods-pic">
                        <div class="goods-detail">
                            <div class="goods-name">御粮 春生 53度550mp</div>
                            <div class="caigou-price">采购价：¥288.9/瓶</div>
                        </div>
                    </div>
                    <div class="price-count">
                        <div class="goods-price">¥126.88</div>
                        <div class="goods-count">x12(箱)</div>
                    </div>
                </div>
                <div class="order-address">
                    <span>2020-09-09</span>
                    <div class="btn-invoice">申请发票</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.page-container{
    min-height:calc(100vh - 46px);
    padding-top: 36px;
    background:#fafafa;
    .top-notice{
        width:100vw;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        padding:0 11px;
        background:#bad7fb;
        font-size: 14px;
        color:#1671E1;
        position: fixed;
        top:46px;
        left:0;
        z-index: 2;
    }
    .invoice-list{
        padding:10px;
        .stock-item{
            background:#fff;
            margin-top: 10px;
            padding:0 15px;
            @media screen and (max-width: 750px){
                border-radius: 4px;
            }
            .time-status{
                height:50px;
                line-height: 50px;
                box-sizing: border-box;
                color:#333;
                border-bottom:1px solid #f0f0f0;
                font-size: 16px;
            }
            .goods-bock{
                padding:15px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .goods-info-block{
                    width:220px;
                    display: flex;
                    justify-content: flex-start;
                    .goods-pic{
                        width:60px;
                        height:60px;
                        margin-right: 10px;
                        border-radius: 4px;
                    }
                    .goods-detail{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .goods-name{
                            width:180px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            color:#000;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
                .price-count{
                    width: 80px;
                    text-align: right;
                    .goods-price{
                        color:#333;
                        line-height: 20px;
                        margin-bottom: 10px;
                        font-size: 14px;
                    }
                    .goods-count{
                        color:#3088F5;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .order-address{
                height:50px;
                font-size: 14px;
                color:#999;
                box-sizing: border-box;
                border-top:1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .btn-invoice{
                    width:90px;
                    height:30px;
                    line-height: 30px;
                    text-align: center;
                    border:1px solid #dcdada;
                    @media screen and (max-width:750px){
                        border-radius: 26px;
                    }
                }
            }
        }
    }
}
</style>